import { render, staticRenderFns } from "./MySpecificProducts.vue?vue&type=template&id=3e09bc6e&scoped=true"
import script from "./MySpecificProducts.vue?vue&type=script&lang=js"
export * from "./MySpecificProducts.vue?vue&type=script&lang=js"
import style0 from "./MySpecificProducts.vue?vue&type=style&index=0&id=3e09bc6e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e09bc6e",
  null
  
)

export default component.exports